import clsx from 'clsx';
import { ButtonHTMLAttributes, FC, ReactNode } from 'react';

export type PaginationItemProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    data: number | string | ReactNode;
    isActive: boolean;
};

const PaginationItem: FC<PaginationItemProps> = ({ isActive, data, ...props }) => {
    return (
        <button
            className={clsx(
                isActive && 'border border-blue-500 text-blue-500 font-semibold',
                'py-0.5 px-1 lg:px-1.5 text-[11px] lg:text-xs leading-4 min-h-6 lg:min-h-6 cursor-pointer hover:bg-gray-100 rounded-md block',
            )}
            {...props}
        >
            {data}
        </button>
    );
};

export default PaginationItem;
